module.exports = __webpack_public_path__ + "static/media/option-3.60c18051.png";